// extracted by mini-css-extract-plugin
export default {"CopyButton":"CopyButton__CopyButton___zFsVz","button":"CopyButton__button___qzeNL","buttonVertical":"CopyButton__buttonVertical___rX3iU"};